import React, { useState } from 'react';
import { LinkButton, ListWrapper, useToast } from '@builtbypixel/nucleus';
import { IconButton, Switch, Flex, Button } from '@builtbypixel/plasma';
import { FiEdit, FiTrash2 } from 'react-icons/fi';
// Import service
import { deleteItem } from '../../services/api.js';
import setup from './setup';

const SimpleModal = ({ isOpen, onClose, title, children, footer }) => {
  if (!isOpen) return null;
  
  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000
      }}
      onClick={onClose}
    >
      <div 
        style={{
          backgroundColor: 'white',
          padding: '20px',
          borderRadius: '5px',
          width: '400px',
          maxWidth: '90%'
        }}
        onClick={e => e.stopPropagation()}
      >
        <div style={{fontWeight: 'bold', fontSize: '18px', marginBottom: '15px'}}>{title}</div>
        <div style={{marginBottom: '20px'}}>{children}</div>
        <div>{footer}</div>
      </div>
    </div>
  );
};

// Extra Menu appears next to the create button
const extraMenu = () => {
    return null;
};

const List = () => {
    const [deleteModal, setDeleteModal] = useState({ isOpen: false, itemId: null });
    const toast = useToast();

    const handleDelete = async () => {
        try {
            await deleteItem(setup.endpoint, deleteModal.itemId);
            
            toast({
                title: 'Success',
                description: 'Item deleted successfully',
                status: 'success',
                duration: 3000,
                isClosable: true,
            });
            
            setDeleteModal({ isOpen: false, itemId: null });
            
            // Refresh the list
            if (window.location.reload) {
                window.location.reload();
            }
        } catch (error) {
            toast({
                title: 'Error',
                description: error.message || 'Failed to delete item',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        }
    };

    const columns = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Mosque Name',
            accessor: 'name',
            Cell: ({ row, value }) => (
                <LinkButton
                    to={`${setup.model}/edit/${row.original[setup.accessor]}`}
                >
                    <IconButton
                        variant='link'
                        variantColor='primary'
                        rounded='md'
                        align='left'
                    >
                        {value}
                    </IconButton>
                </LinkButton>
            ),
        },
        {
            Header: 'Is Master Mosque?',
            accessor: 'master_mosque',
            Cell: ({ row }) => (row.original.master_mosque ? 'Yes' : 'No'),
        },
        {
            Header: 'Mosque Email',
            accessor: 'mosque_email',
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <Flex>
                    <LinkButton
                        to={`${setup.model}/edit/${row.original[setup.accessor]}`}
                        mr={2}
                    >
                        <IconButton
                            icon={<FiEdit />}
                            aria-label="Edit"
                            variant="outline"
                            variantColor="blue"
                            size="sm"
                        />
                    </LinkButton>
                    <IconButton
                        icon={<FiTrash2 />}
                        aria-label="Delete"
                        variant="outline"
                        variantColor="red"
                        size="sm"
                        onClick={() => setDeleteModal({ 
                            isOpen: true, 
                            itemId: row.original[setup.accessor] 
                        })}
                    />
                </Flex>
            ),
        }
    ];

    return (
        <>
            <ListWrapper setup={setup} columns={columns} extraMenu={extraMenu} />
            
            {/* Using SimpleModal instead */}
            <SimpleModal
                isOpen={deleteModal.isOpen}
                onClose={() => setDeleteModal({ isOpen: false, itemId: null })}
                title="Confirm Delete"
                footer={
                    <Flex justifyContent="flex-end">
                        <Button 
                            variant="outline" 
                            mr={3} 
                            onClick={() => setDeleteModal({ isOpen: false, itemId: null })}
                        >
                            Cancel
                        </Button>
                        <Button 
                            variant="solid" 
                            variantColor="red" 
                            onClick={handleDelete}
                        >
                            Delete
                        </Button>
                    </Flex>
                }
            >
                Are you sure you want to delete this mosque? This action cannot be undone.
            </SimpleModal>
        </>
    );
};

export default List;